//文字信息汇总
export const BRAND = '澳门金沙'
export const MachineType = 'h5' //h5-andrioid-ios  机器类型
export const UserFunc = [
    //用户个人中心功能
    {
        name: '账变记录',
        routerName: 'accountChange', //路由名
        imgurl: 'AccountChange.png', //img
        bettingRecord: true //是否属于投注记录,后台可以控制是否显示投注记录,userInfo.user.show_betting_status == 1显示投注记录, 默认为false
    },
    {
        name: '资金明细',
        routerName: 'fundRecord',
        imgurl: 'funds.png',
        bettingRecord: true
    },
    {
        name: '投注记录',
        routerName: 'gameRecord',
        imgurl: 'gemjl.png',
        bettingRecord: true
    },
    {
        name: '优惠记录',
        routerName: 'discount',
        imgurl: 'record_icon.png',
        bettingRecord: true
    },
    {
        name: 'VIP特权',
        routerName: 'vipPrivilege',
        imgurl: 'VIPnew.png',
        bettingRecord: true
    },
    {
        name: '电子工资卡',
        routerName: 'salaryCard',
        imgurl: 'SalaryCard.png',
        bettingRecord: true
    },
    {
        name: '我的优惠券',
        routerName: 'myDiscount',
        imgurl: 'discounts.png'
    },
    {
        name: '账户安全',
        routerName: 'safeCenter',
        imgurl: 'security.png'
    },
    // {
    // 	name: '消息中心',
    // 	routerName: 'message',
    // 	imgurl: 'Message.png',
    // },
    {
        name: '高级代理',
        routerName: 'proxyContry',
        imgurl: 'SenioRagent.png',
        bettingRecord: true
    },
    {
        name: '线路检测',
        routerName: 'network',
        imgurl: 'line.png'
    },
    {
        name: '帮助中心',
        routerName: 'helpCenter',
        imgurl: 'Help.png'
    },
    {
        name: '版本检测',
        routerName: 'modal', //弹窗
        imgurl: 'version.png'
    }
]
export const NAV_LIST = [
    //左侧菜单树
    //路由-名称
    { path: '/', value: '首&ensp;&ensp;&ensp;&ensp;页', imgurl: '1.png' },
    { path: '/game/live', value: '真人视讯', imgurl: '2.png' },
    { path: '/game/im', value: 'IM电竞', imgurl: 'im.png' },
    { path: '/game/slot', value: '电子游艺', imgurl: '3.png' },
    { path: '/game/sport', value: '激情体育', imgurl: '6.png' },
    { path: '/game/lottery', value: '福利彩票', imgurl: '5.png' },
    { path: '/game/chess', value: '经典棋牌', imgurl: '4.png' },
    { path: '/game/fishing', value: '捕鱼达人', imgurl: '7.png' },
    { path: '/recentlyPlayed', value: '我玩过的游戏', imgurl: '8.png' },
    { path: '/collectGm', value: '我收藏的游戏', imgurl: '9.png' },
    { path: '/try/PlayList', value: '试玩中心', imgurl: '10.png' },
    { path: '/vipIntroduction', value: 'VIP特权', imgurl: '11.png', bettingRecord: true },
    { path: '/user/helpcenter', value: '帮助中心', imgurl: '12.png' },
    { path: 'loginOut', value: '登入/登出', imgurl: '13.png' }
]
// NAV_LIST.map((el, i) => {
// 	el.icon = require('@/assets/img/home/slider/' + (i + 1) + '.png');
// 	return el;
// });
export const AG_GAME_CONFIG = {
    //AG游戏配置
    AG_LIVE: '67',
    AG_XIN: '68',
    AG_FISHING: '69',
    AG_YOPLAY: '70',
    AG_TRANSFER: '67',
    AG_NAME: 'AG/XIN/AG捕鱼/YOPLAY'
}

export const SLOT_GAME_CONFIG = {
    PT_SLOT: '66',
    PT_NAME: 'PT老虎机',
    BBIN_SLOT: '46',
    BBIN_TRANSFER: '39',
    BBIN_NAME: 'BBIN',
    CQ9_SLOT: '88',
    CQ9_NAME: 'CQ9',
    MG_SLOT: '42',
    MG_NAME: 'MG老虎机'
}

export const SPORT_GAME_CONFIG = {
    //体育游戏配置
    SB_SPORT: '41',
    SB_SPORT_NAME: '沙巴体育',
    BBIN_SPORT: '40',
    BBIN_SPORT_NAME: 'BBIN体育',
    HG_SPORT: '35',
    HG_SPORT_NAME: '皇冠体育'
}

export const LIVE_GAME_CONFIG = {
    //真人配置
    AG_LIVE: '67',
    AG_LIVE_NAME: 'AG/XIN/AG捕鱼/YOPLAY',
    BBIN_LIVE: '39',
    BBIN_LIVE_NAME: 'BBIN真人',
    BG_LIVE: '43',
    BG_LIVE_NAME: 'BG真人',
    SA_LIVE: '38',
    SA_LIVE_CONFIG: 'SA真人'
}

export const CHESS_GAME_CONFIG = {
    //棋牌配置
    KY_CHESS: '44',
    KY_CHESS_NAME: '开元棋牌',
    LC_CHESS: '112',
    LC_CHESS_NAME: '凯旋棋牌',
    LY_CHESS: '105',
    LY_CHESS_NAME: '乐游棋牌'
}

export const LOTTERY_GAME_CONFIG = {
    //彩票配置
    IG_SSC: '54',
    IG_SSC_NAME: '时时彩',
    IG_XGC: '53',
    IG_XGC_NAME: '香港彩',
    IG_GFC: '52',
    IG_GFC_NAME: '官方彩',
    IG_TRANSFER: '52'
}

export const RES_ERROR_STATUS = {
    //常见报错信息
    10000001: '很抱歉，我们的系统正在维护,开启时间请咨询在线客服',
    10000002: '很抱歉，您访问的接口已经关闭',
    10000003: '您不具备访问权限',
    10000004: '很抱歉，您所在的用户组已经关闭',
    10000005: '很抱歉，您的账号已经被系统冻结，如有疑问请咨询客服',
    10000006: '您还没有登录',
    10000007: '您的求情参数错误',
    10000008: '很抱歉，您所在的角色组已经被关闭',
    10000009: '很抱歉，您访问的链接存在错误',
    10000011: '当前IP限制访问 / 无效请求 / 黑名单',
    100000012: '无效请求',
    100000013: '无效请求',
    100000014: '无效请求',
    10000015: '您的账户目前处于资金冻结状态，详情请联系客服',
    10000016: '请求过于频繁'
}
